import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

const ManageBudgetCard = ({estBudget, listItem}) => {
    const [budgetItems, setbudgetItems] = useState([]);
    const [paidAmount, setpaidAmount] = useState(0);
    const [owingAmount, setowingAmount] = useState(0);
    const [totalAmount, settotalAmount] = useState(0);

    useEffect(() => {
        const loadItems = () => {
            setbudgetItems(listItem)
        }
        loadItems()
        const calculationDataLoad = () => {
            let paid = 0
            let owing = 0
            let total = 0
            for (let i = 0; i < listItem.length; i++) {
                total = total + parseInt(listItem[i].price)
                if (listItem[i].isPaid) {
                    paid = paid + parseInt(listItem[i].price)
                }
                if (listItem[i].isPaid === null) {
                    owing = owing + parseInt(listItem[i].price)
                }
                if (i === (listItem.length - 1)) {
                    setpaidAmount(paid)
                    setowingAmount(owing)
                    settotalAmount(total)
                }
            }
        }
        calculationDataLoad()
    }, [listItem]);

    
    return (
        <div className='budget-card'>
            <div className="budget-ammount">
                <h4>Manage Budget</h4>
                <h2>${estBudget && estBudget}</h2>
            </div>
            <div className="buying-items">
                {budgetItems.length > 0 &&
                budgetItems.map((item) => (
                    <div className="buy-card" key={item.id}>
                        <h6>{item.itemName}</h6>
                        <h6>${item.price}</h6>
                    </div>
                ))}

            </div>
            <div className="budget-calculation">
                <div className="calculation-item">
                    <h6>Paid Amount</h6>
                    <h6>: ${paidAmount}</h6>
                </div>
                <div className="calculation-item">
                    <h6>Amount Owing</h6>
                    <h6>: ${owingAmount}</h6>
                </div>
                <div className="calculation-item">
                    <h6>Total Amount</h6>
                    <h6>: ${totalAmount}</h6>
                </div>
            </div>
        </div>
    );
};

export default ManageBudgetCard;
